import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslations from "./locales/en.json";
import frTranslations from "./locales/fr.json";

// Get saved language from localStorage, detect browser language, or default to 'fr'
const getStoredLanguage = (): string => {
  if (typeof window !== "undefined") {
    // First, check if user has explicitly set a language preference
    const stored = localStorage.getItem("language");
    if (stored === "en" || stored === "fr") {
      return stored;
    }

    // If no stored preference, detect browser language
    const browserLang =
      navigator.language || (navigator.languages && navigator.languages[0]) || "fr";
    // Extract base language code (e.g., "fr-FR" -> "fr", "en-US" -> "en")
    const baseLang = browserLang.split("-")[0].toLowerCase();

    // Check if browser language is supported
    if (baseLang === "fr" || baseLang === "en") {
      return baseLang;
    }
  }
  return "fr";
};

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: enTranslations,
    },
    fr: {
      translation: frTranslations,
    },
  },
  lng: getStoredLanguage(),
  fallbackLng: "fr",
  interpolation: {
    escapeValue: false,
  },
});

// Listen for language changes and save to localStorage
i18n.on("languageChanged", (lng) => {
  if (typeof window !== "undefined") {
    localStorage.setItem("language", lng);
  }
});

export default i18n;
